import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const auth = {
  username: process.env.VUE_APP_USERNAME,
  password: process.env.VUE_APP_PASSWORD,
};

export default new Vuex.Store({
  state: {
    site: [],
    exhibitions: [],
    publications: [],
    fairs: [],
    exhibition: [],
    fair: [],
    publication: [],
    artist: [],
    contact: [],
  },
  getters: {
    getProjectByUID: (state) => (uid, collection = state.projects) => {
      let i = collection.length;
      while (i--) {
        if (collection[i].uid === uid) {
          return collection[i];
        }
      }
    },
  },
  actions: {
    async loadSite({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "site",
            select: {
              title: true,
              url: true,
              menu: {
                query: "site.children.listed",
                select: {
                  title: true,
                  uid: true,
                },
              },
              artists: {
                query: "page('artists').children.listed",
                select: {
                  title: true,
                  uid: true,
                  count: "page.images.filterBy('show', true).count",
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_SITE", response.data.result);
        });
    },
    async loadExhibitions({ commit }, payload) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('exhibitions')",
            select: {
              items: {
                query:
                  "page.children.listed.sortBy('year', 'desc', 'num', 'asc')",
                select: {
                  title: true,
                  uid: true,
                  year: true,
                },
                pagination: {
                  page: payload,
                  limit: 100,
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_EXHIBITIONS", response.data.result.items);
        });
    },
    async loadExhibition({ commit }, payload) {
      await axios
        .post(
          "/api/query",
          {
            query: `page('exhibitions').children.find('${payload}')`,
            select: {
              title: true,
              uid: true,
              year: true,
              text: "page.text.kirbytext",
              document: {
                query: "page.document.toFiles",
                select: {
                  url: "file.url",
                  caption: "file.text",
                },
              },
              images: {
                query: "page.gallery.toFiles",
                select: {
                  srcset: "file.srcset([400,800,1200,1600,2000])",
                  url: "file.resize(1200).url",
                  thumb: "file.resize(200).url",
                  caption: "file.text.kirbytext",
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_EXHIBITION", response.data.result);
        });
    },
    async loadPublications({ commit }, payload) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('publications')",
            select: {
              items: {
                query: "page.children.listed",
                select: {
                  title: true,
                  uid: true,
                },
                pagination: {
                  page: payload,
                  limit: 100,
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_PUBLICATIONS", response.data.result.items);
        });
    },
    async loadPublication({ commit }, payload) {
      await axios
        .post(
          "/api/query",
          {
            query: `page('publications').children.find('${payload}')`,
            select: {
              title: true,
              uid: true,
              text: "page.text.kirbytext",
              num: "page.num",
              document: {
                query: "page.document.toFiles",
                select: {
                  url: "file.url",
                  caption: "file.text",
                },
              },
              images: {
                query: "page.gallery.toFiles",
                select: {
                  srcset: "file.srcset([400,800,1200,1600,2000])",
                  url: "file.resize(1200).url",
                  thumb: "file.resize(200).url",
                  caption: "file.text.kirbytext",
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_PUBLICATION", response.data.result);
        });
    },
    async loadFairs({ commit }, payload) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('fairs')",
            select: {
              items: {
                query: "page.children.listed",
                select: {
                  title: true,
                  uid: true,
                  year: true,
                },
                pagination: {
                  page: payload,
                  limit: 100,
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_FAIRS", response.data.result.items);
        });
    },
    async loadFair({ commit }, payload) {
      await axios
        .post(
          "/api/query",
          {
            query: `page('fairs').children.find('${payload}')`,
            select: {
              title: true,
              uid: true,
              year: true,
              text: "page.text.kirbytext",
              document: {
                query: "page.document.toFiles",
                select: {
                  url: "file.url",
                  caption: "file.text",
                },
              },
              images: {
                query: "page.gallery.toFiles",
                select: {
                  srcset: "file.srcset([400,800,1200,1600,2000])",
                  url: "file.resize(1200).url",
                  thumb: "file.resize(200).url",
                  caption: "file.text.kirbytext",
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_FAIR", response.data.result);
        });
    },
    async loadArtist({ commit }, payload) {
      await axios
        .post(
          "/api/query",
          {
            query: `page('artists').children.find('${payload}')`,
            select: {
              title: true,
              uid: true,
              images: {
                query: "page.images.sortBy('sort').filterBy('show', true)",
                select: {
                  srcset: "file.srcset([400,800,1200,1600,2000])",
                  url: "file.resize(1200).url",
                  thumb: "file.resize(200).url",
                  caption: "file.text.kirbytext",
                  description: "file.description.kirbytext",
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_ARTIST", response.data.result);
        });
    },
    async loadContact({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('contact')",
            select: {
              title: true,
              uid: true,
              contact: "page.contact.kirbytext",
              text: "page.text.kirbytext",
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_CONTACT", response.data.result);
        });
    },
  },
  mutations: {
    SET_SITE(state, data) {
      state.site = data;
    },
    SET_EXHIBITIONS(state, pages) {
      state.exhibitions = pages;
    },
    SET_EXHIBITION(state, project) {
      state.exhibition = project;
    },
    SET_PUBLICATIONS(state, pages) {
      // if (state.publications.pagination) {
      //   state.publications.pagination = pages.pagination;
      //   for (var i = 0; i < pages.data.length; i++) {
      //     state.publications.data.push(pages.data[i]);
      //   }
      // } else {
        state.publications = pages;
      // }
    },
    SET_PUBLICATION(state, project) {
      state.publication = project;
    },
    SET_FAIRS(state, pages) {
      // if (state.fairs.pagination) {
      //   state.fairs.pagination = pages.pagination;
      //   for (var i = 0; i < pages.data.length; i++) {
      //     state.fairs.data.push(pages.data[i]);
      //   }
      // } else {
        state.fairs = pages;
      // }
    },
    SET_FAIR(state, project) {
      state.fair = project;
    },
    SET_ARTIST(state, project) {
      state.artist = project;
    },
    SET_CONTACT(state, data) {
      state.contact = data;
    },
  },
});
